import { encryptText, pbdkf2 } from "./OstreonEncryption";
import SHA from "sha.js";

export const buildPrivateKey = (private_key, email, birth_date, personal_code) => {
    return new Promise(async (resolve, reject) => {
      try {
        const key_elements = `${email.toLowerCase()}:${
          birth_date
        }:${personal_code.toLowerCase()}`;
        const beneficiary_key = SHA("sha256")
          .update(key_elements)
          .digest("hex");
        const password = await pbdkf2(key_elements, "OSTREON", 100000, 32 * 8);
        const encrypted_key = await encryptText(beneficiary_key, private_key);
        resolve({ email, encrypted_key, password:password[0] });
      } catch (error) {
        reject(error);
      }
    });
  };